import Vue from 'vue'
import parsePhoneNumber from 'libphonenumber-js'

Vue.filter('telephone', value => {
  if (!value) {
    return ''
  }

  if (typeof value === 'object') {
    if (!value.iso) {
      return value.prefix.toString() + ' ' + value.number.toString()
    }

    const phoneNumber = parsePhoneNumber(value.iso)
    if (!phoneNumber) {
      return value.prefix.toString() + ' ' + value.number.toString()
    }

    return phoneNumber.formatNational()
  }

  if (typeof value === 'string') {
    return value
  }

  return ''
})
